(function(){
  var isUS = window.location.pathname.indexOf('/en-us') === 0;
  if(!isUS) return;
  // Product pages (.product__tax) + cart drawer and cart page (.tax-note)
  var US_TAX_TEXT = 'Duties & tax included. Shipping $15 or free for orders above $400.';
  function applyUS(){
    document.querySelectorAll('.product__tax, .tax-note').forEach(function(el){
      // Only rewrite when needed: rewriting unconditionally re-triggers the observer (infinite loop)
      if (el.textContent.trim() !== US_TAX_TEXT) el.textContent = US_TAX_TEXT;
    });
  }
  var scheduled = false;
  var obs = new MutationObserver(function(){
    if (scheduled) return;
    scheduled = true;
    setTimeout(function(){ scheduled = false; applyUS(); }, 0);
  });
  function init(){
    applyUS();
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
